import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Field, reduxForm } from 'redux-form'
import { Col, Row } from 'react-bootstrap'
import { get, find } from 'lodash'

import {
  required,
  postalCode,
  stringLatinCharactersAndQuotes,
  houseNumber,
  validateBirthDate,
  validateBusinessNumber,
  number,
} from 'Utils/Validators/formValidation'
import MomentUtils from '@date-io/moment'
import { Input } from 'Components/Form/Input'
import { Dropzone } from 'Components/Form/Dropzone'
import SubmitButton from 'Components/Form/SubmitButton'
import { SelectDashboard } from 'Components/Form/SelectDashboard'
import { SubmitButtonBlock } from 'Components/Form/SubmitButton/SubmitButtonBlock'
import { ContactDetailsWrapper } from 'Components/City/Form/Ambassador/ContactDetailsWrapper/index.js'
import moment from 'moment'
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers'
import { getContractorTypesOptionsByCountryCode } from '../../../../../Utils/Misc'
import { BA_CATEGORY_OPTIONS, COUNTRY_CODE } from '../../../../../constants'
import { getBADateOfBirth } from '../../../../../Utils/User'
import { authorization } from '../../../../../Module/Auth/Auth'

const DATE_OF_BIRTH_FORMAT = 'DD-MM-YYYY'
class AmbassadorContactDetailsForm extends PureComponent {
  validateBirthDateHandler = value =>
    validateBirthDate(value, this.props.countryCode, DATE_OF_BIRTH_FORMAT)

  validateBusinessNumberHandler = value =>
    validateBusinessNumber(this.props.countryCode)(value)

  render = (
    {
      ambassador,
      handleSubmit,
      citiesOptions,
      canShowContractorType,
      canShowBaType,
      canShowGermanyPaymentId,
      countryCode,
    } = this.props,
  ) => {
    const canSeeSensitiveData = !authorization.isCityManagerAssistant()
    return (
      <form>
        <ContactDetailsWrapper>
          <Col xs={2}>
            <Col xs={3}>
              <Field
                component={Dropzone}
                name="profilePicture"
                src={ambassador.profilePicture}
              />
            </Col>
          </Col>
          <Col xs={10}>
            <Row>
              <Col xs={3}>
                <p className="col-title">Email Address</p>
                <p className="email">{ambassador.email}</p>
              </Col>
              <Col xs={3}>
                <p className="col-title">First Name</p>
                <Field name="firstName" id="firstName" component={Input} />
              </Col>
              <Col xs={3}>
                <p className="col-title">Last Name</p>
                <Field name="lastName" id="lastname" component={Input} />
              </Col>
            </Row>
            <Row>
              <Col xs={3}>
                <p className="col-title">Phone number</p>
                <Field component={Input} name="mobilePhone" id="mobilePhone" />
              </Col>
              {countryCode !== COUNTRY_CODE.UNITED_STATES &&
                canSeeSensitiveData && (
                  <Col xs={3}>
                    <p className="col-title">
                      {businessNumberTitle(countryCode)}--
                    </p>
                    <Field
                      component={Input}
                      name="abn"
                      id="abn"
                      validate={this.validateBusinessNumberHandler}
                    />
                  </Col>
                )}
            </Row>
            <Row>
              <Col xs={3}>
                <p className="col-title">City</p>
                <Field
                  name="cityId"
                  component={SelectDashboard}
                  options={citiesOptions}
                  props={{ sorted: true }}
                />
              </Col>
              {canShowContractorType ? (
                <Col xs={3}>
                  <p className="col-title">Contractor type</p>
                  <Field
                    name="contractorType"
                    component={SelectDashboard}
                    options={getContractorTypesOptionsByCountryCode(
                      countryCode,
                    )}
                  />
                </Col>
              ) : null}
              {canShowBaType ? (
                <Col xs={3}>
                  <p className="col-title">BA type</p>
                  <Field
                    name="category"
                    component={SelectDashboard}
                    options={BA_CATEGORY_OPTIONS}
                  />
                </Col>
              ) : null}
            </Row>
            <Row>
              {ambassador &&
                ambassador.city &&
                countryCode == COUNTRY_CODE.GERMANY &&
                this.props.ambassador.germanyPayrollData && (
                  <Col xs={3}>
                    <p className="col-title">Middle Name</p>
                    <Field
                      name="middleName"
                      id="middlename"
                      component={Input}
                    />
                  </Col>
                )}

              {countryCode && countryCode !== COUNTRY_CODE.NETHERLANDS && (
                <Col xs={3}>
                  <p className="col-title">Date of Birth</p>
                  <MuiPickersUtilsProvider
                    libInstance={moment}
                    utils={MomentUtils}
                  >
                    <Field
                      name="dateOfBirth"
                      component={ReduxDatePickerField}
                      validate={this.validateBirthDateHandler}
                    />
                  </MuiPickersUtilsProvider>
                </Col>
              )}
              {ambassador &&
                ambassador.city &&
                countryCode == COUNTRY_CODE.GERMANY &&
                this.props.ambassador.germanyContractData && (
                  <React.Fragment>
                    <Col xs={3}>
                      <p className="col-title">Address</p>
                      <Field
                        name="address"
                        props={{
                          id: 'address',
                          placeholder: 'Address',
                        }}
                        component={Input}
                        validate={[required, stringLatinCharactersAndQuotes]}
                      />
                    </Col>
                    <Col xs={3}>
                      <p className="col-title">No.</p>
                      <Field
                        name="houseNumber"
                        props={{
                          id: 'houseNumber',
                          placeholder: 'House number',
                        }}
                        component={Input}
                        validate={[required, houseNumber]}
                        onError={error => alert(error)}
                      />
                    </Col>
                    <Col xs={3}>
                      <p className="col-title">Apartment, suite etc.</p>
                      <Field
                        name="exactAddress"
                        props={{
                          id: 'exactAddress',
                          placeholder: 'e.g. Block A, 3rd floor',
                        }}
                        component={Input}
                      />
                    </Col>
                    <Col xs={3}>
                      <p className="col-title">City of Residence</p>
                      <Field
                        name="residenceCity"
                        props={{
                          id: 'residenceCity',
                        }}
                        component={Input}
                        validate={[required, stringLatinCharactersAndQuotes]}
                      />
                    </Col>
                    <Col xs={3}>
                      <p className="col-title">Postcode (PLZ)</p>
                      <Field
                        name="postalCode"
                        id="postalcode"
                        component={Input}
                        validate={[required, postalCode]}
                      />
                    </Col>
                  </React.Fragment>
                )}
              {canShowGermanyPaymentId ? (
                <Col xs={3}>
                  <p className="col-title">Payment ID</p>
                  <Field
                    name="germanyPaymentId"
                    id="germanyPaymentId"
                    component={Input}
                    validate={[required, number]}
                  />
                </Col>
              ) : null}
            </Row>
          </Col>
        </ContactDetailsWrapper>
        <Row>
          <SubmitButtonBlock>
            <SubmitButton value="Save" onClick={handleSubmit} />
          </SubmitButtonBlock>
        </Row>
      </form>
    )
  }
}

const ambassadorById = state => state.ambassadors.ambassadorById
const findCityByName = (cities, ambassador) =>
  find(cities, ['name', get(ambassadorById(ambassador), 'city.name')])

export const businessNumberTitle = country => {
  switch (country) {
    case 'FR':
      return 'SIRET'
    case 'UK':
      return 'UTR'
    case 'AU':
      return 'ABN'
    default:
      return 'Business Number'
  }
}

AmbassadorContactDetailsForm.propTypes = {
  ambassador: PropTypes.object.isRequired,
  cities: PropTypes.array.isRequired,
}

const mapStateToProps = (state, initialProps) => ({
  initialValues: {
    firstName: get(ambassadorById(state), 'firstName'),
    lastName: get(ambassadorById(state), 'lastName'),
    cityId: get(findCityByName(initialProps.cities, state), 'id'),
    mobilePhone: get(ambassadorById(state), 'mobilePhone'),
    abn: get(ambassadorById(state), 'businessNumber'),
    middleName: get(
      get(ambassadorById(state), 'germanyPayrollData'),
      'middleName',
    ),
    dateOfBirth: getBADateOfBirth(ambassadorById(state)),
    address: get(get(ambassadorById(state), 'germanyContractData'), 'address'),
    houseNumber: get(
      get(ambassadorById(state), 'germanyContractData'),
      'houseNumber',
    ),
    exactAddress: get(
      get(ambassadorById(state), 'germanyContractData'),
      'exactAddress',
    ),
    residenceCity: get(
      get(ambassadorById(state), 'germanyContractData'),
      'city',
    ),
    postalCode: get(
      get(ambassadorById(state), 'germanyContractData'),
      'postalCode',
    ),
    contractorType: get(ambassadorById(state), 'contractorType'),
    category: get(ambassadorById(state), 'category'),
    germanyPaymentId: get(ambassadorById(state), 'germanyPaymentId'),
  },
  ambassador: ambassadorById(state),
  citiesOptions: initialProps.cities.map(c => ({
    label: c.name,
    value: c.id,
  })),
})

const ReduxDatePickerField = ({
  input,
  meta,
  format = DATE_OF_BIRTH_FORMAT,
}) => {
  return (
    <DatePicker
      error={meta.error}
      helperText={meta.error}
      value={input.value ? moment(input.value) : null}
      format={format}
      onChange={value => {
        return value && input.onChange(moment(value).utc())
      }}
    />
  )
}

AmbassadorContactDetailsForm = reduxForm({
  form: 'ambassador-contact-details-form',
  enableReinitialize: true,
})(AmbassadorContactDetailsForm)

AmbassadorContactDetailsForm = connect(
  mapStateToProps,
  null,
)(AmbassadorContactDetailsForm)

export { AmbassadorContactDetailsForm }
